import _ from 'lodash';
import React from 'react';
import Helper from './Helper';
import YoutubeEmbed from './YoutubeEmbed';

class ProductSlides extends React.Component {
    render(){
        let {items, title, videoUrl} = this.props;
        let  $ = window.jQuery;

        let thumbs = [];
        if(!_.isEmpty(videoUrl)) {
            thumbs.push(<div key={"product-video"} className="swiper-slide">
                <a className="slide-wrap__thumb__item video fancybox" data-fancybox href={videoUrl}>
                    <div className='video-container'>
                        <img src={Helper.getYoutubeVideoThumbnail(videoUrl)} alt={title}/>
                        <i className="play-icon far fa-play-circle"></i>
                    </div>
                </a>
            </div>);
        }

        if(items) {
            items.forEach((item, index) => {
                thumbs.push(<div key={index} className="swiper-slide">
                    <a  className="fancybox slide-wrap__thumb__item" data-fancybox="gallery" 
                        data-caption={item.title} 
                        data-thumbnail={item.thumb} 
                        href={item.full_image}  data-fancybox-group="gallery" title={item.title}>
                        <img src={item.thumb} alt={title}  className={`img-fluid ${parseInt(item.default) === 1 ? 'active':''}`} style={{width:'75px'}} />
                    </a>
                </div>)
            })
        }

        let mainImg = items ? items.filter((item)=>parseInt(item.default) === 1):null;
        if(mainImg && mainImg.length ===0){
            mainImg = items[0];
        }else if(mainImg.length > 0){
            mainImg = mainImg[0];
        }
        
        let height = $(window).width() < 576 ? 'auto':'450px';
        let order1 = $(window).width() < 576 ? '':'order-1';
        let order2 = $(window).width() < 576 ? '':'order-2';
        let next = $(window).width() < 576 ? <div className="swiper-button-next"></div>:<div className="m-0 p-0 swiper-button-vertical-next">
                                                <span className='swiper-arrow'><i className="m-0 p-0 fas fa-chevron-up"></i></span>
                                            </div>;
        let prev = $(window).width() < 576 ? <div className="swiper-button-prev"></div>:<div className="m-0 p-0 swiper-button-vertical-prev">
                                                <span className='swiper-arrow'><i className="m-0 p-0 fas fa-chevron-down"></i></span>
                                            </div>;
        return (
            <div className="slide-wrap__main row mb-4" style={{border:'1px solid #eaeaea',overflow:'hidden',borderLeft:'none'}} >
                <div className={`${order2} py-1 col-12 col-md-9 text-center`} style={{height:height,borderLeft:'1px solid #eaeaea'}}>
                        {mainImg ? 
                        <img src={mainImg.thumb} alt={title} 
                            className="img-fluid w-75 img-center mx-auto mt-2" index="0" />
                        :null}
                </div>
                <div style={{height:height}} 
                    className={`col-12 col-md-3 ${order1} position-relative image-slider swiper-slide-container no-gutters text-center slide-wrap__thumb p-3`}>
                    <div className="swiper-wrapper">
                        {thumbs}
                    </div>
                    {next}
                    {prev}
                </div>
            </div>
        )
    }
}
export default ProductSlides